import React from "react";

export const Logo = ({ className = "", imgClass = "h-24 w-24 sm:h-28 sm:w-28" }) => {
  return (
    <a
      href="#home"
      data-testid="brand-logo"
      className={`inline-flex items-center group ${className}`}
      aria-label="Eknoor Driving School - Home"
    >
      <img
        src="/logo.png"
        alt="Eknoor Driving School"
        className={`${imgClass} rounded-full object-cover select-none transition-transform duration-200 group-hover:scale-105`}
        draggable="false"
        loading="eager"
        decoding="async"
      />
    </a>
  );
};
